import { useQuery } from '@tanstack/react-query';
import { fetchProducts } from '../services/ProductsService';
import { Product } from '../types';

export const useProducts = () => {
    const {
        data: products,
        isLoading,
        error,
        refetch
    } = useQuery({
        queryKey: ['products'],
        queryFn: () => fetchProducts(),
        select: (data) => data?.items || []
    });

    return {
        products: products as Product[] || [],
        isLoading,
        error,
        refetch
    };
};


